import { IMetaFormat, TIFormatPrefix } from '../../../../../../../store/admin/roundFormats/store';

import { groupBy } from '../../../../../../../contrib/utils';
import { getResultFieldName } from '../../../ResultsTable/Utils/getResultFieldName';
import { IStateDispatchActions } from '../AssignResults.context';

export type ISetHorseRaceEliminatedResults = (
  roundFormat: IMetaFormat,
  selectedScoreType: number
) => void;

export const setHorseRaceEliminatedResults: IStateDispatchActions<
  ISetHorseRaceEliminatedResults
> = ({ sortedResults }, dispatch) => async (roundFormat, selectedScoreType) => {
  const {
    considerFlights,
    format: { prefix: selectedFormatPrefix }
  } = roundFormat;

  const isHorse = selectedFormatPrefix === 'horse';

  if (isHorse) {
    const processedPrefix = `${selectedFormatPrefix}${
      considerFlights ? 'Flight' : 'Round'
    }` as TIFormatPrefix;

    const positionFieldName = getResultFieldName(processedPrefix, selectedScoreType, 'Eliminated');

    dispatch({
      type: 'setHorseRaceEliminatedResults',
      value: groupBy(sortedResults, positionFieldName)
    });
  }
};
